import { Component, OnInit } from "@angular/core";
import { BaseUserService } from "@smarterplan/ngx-smarterplan-core";

@Component({
    selector: "app-layout",
    template: `
        <app-dashboard-header></app-dashboard-header>
        <router-outlet></router-outlet>
    `,
    styleUrls: ["../../block.scss"],
})
export class LayoutComponent implements OnInit {
    constructor(private userService: BaseUserService) { }

    ngOnInit(): void { }
}
